export const PartnerSearchType = {
  LANDLORD: 'LANDLORD',
  OEM: 'OEM',
} as const;

export type PartnerSearchType =
  (typeof PartnerSearchType)[keyof typeof PartnerSearchType];
